import packageInfo from '../package.json';

const ENV = window?.env || {};

export const appVersion = packageInfo.version;
export const config = {
	mode: ENV.REACT_APP_MODE || 'dev', // dev, prd
	baseURL: ENV.REACT_APP_BASE_URL || 'http://localhost:3000',
	api_endpoint:
		ENV.REACT_APP_API_ENDPOINT ||
		// 'http://localhost:3002',
		'https://services-uat.prudential.co.th/api',
	api_endpoint_filenet:
		ENV.REACT_APP_API_ENDPOINT_FILENET ||
		'https://services-uat.prudential.co.th/api',
	ga: ENV.REACT_APP_GA_ID || 'UA-116129900-3',
	mix: ENV.REACT_APP_MIX_ID || '68c7055c2614906eb5fd66bdac08d437',
	liff_id: {
		contact: ENV.REACT_APP_LIFF_ID_CONTACT || '1557349447-bgar7KBJ',
		regisAutoDebit: ENV.REACT_APP_LIFF_ID_REGIS_AUTO_DEBIT || '1557349447-DEOy1pBz',
		digitalPayment: ENV.REACT_APP_LIFF_ID_DIGITAL_PAYMENT || '1557349447-ENjxd8WN',
		paymentBenefit:
			ENV.REACT_APP_LIFF_ID_PAYMENT_BENEFIT || '1557349447-75YdOaxq',
		login: ENV.REACT_APP_LIFF_ID_LOGIN || '1557349447-kR8DxQnY',
		setting: ENV.REACT_APP_LIFF_ID_SETTING || '1557349447-pg4vePGl',
		policy: ENV.REACT_APP_LIFF_ID_POLICY || '1557349447-Gjgkw9jE',
		policyDetail:
			ENV.REACT_APP_LIFF_ID_POLICY_DETAIL || '1557349447-dmX9PN2E',
		policyDetailTtbTC:
			ENV.REACT_APP_LIFF_ID_POLICY_DETAIL_TTBTC || '1557349447-baGjQJ8Z',
		policyLoan: ENV.REACT_APP_LIFF_ID_POLICY_LOAN || '1557349447-pg4vePGl',
		paymentPremium:
			ENV.REACT_APP_LIFF_ID_PAYMENT_PREMIUM || '1557349447-pg4vePGl',
		eclaim: ENV.REACT_APP_LIFF_ID_ECLAIM || '1557349447-pg4vePGl',
		personalHealth:
			ENV.REACT_APP_LIFF_ID_PERSONAL_HEALTH || '1557349447-86Wz0AdD',
		hospitalNetwork:
			ENV.REACT_APP_LIFF_ID_HOSPITAL_NETWORK || '1557349447-GvOKXdjA',
		documentsDownload:
			ENV.REACT_APP_LIFF_ID_DOCUMENT_DOWNLOAD || '1557349447-lAzaJ9gk',
		privilege: ENV.REACT_APP_LIFF_ID_PRIVILEGE || '1557349447-Qxn1NPWA',
		privilege_portal: ENV.REACT_APP_LIFF_ID_PRIVILEGE_PORTAL || '1557349447-OqgakrOW',
		changeContact:
			ENV.REACT_APP_LIFF_ID_CHANGE_CONTACT || '1557349447-0ElO4p6D',
		groupEB: ENV.REACT_APP_LIFF_ID_GROUP_EB || '1557349447-zew29ZoV',
		suggestProduct: ENV.REACT_APP_LIFF_ID_SUGGEST_PRODUCT || '1557349447-5MelKA9m',
		searchPartner:
			ENV.REACT_APP_LIFF_ID_SEARCH_PARTNER || '1557349447-BPEoQaAN',
		taxConsent:
			ENV.REACT_APP_LIFF_ID_TAX_CONSENT || '1557349447-Ng8L1k0a',
		lonImmigrate: ENV.REACT_APP_LIFF_ID_LON_IMMIGRATE || '1557349447-pg4vePGl',
		psssoArrival: ENV.REACT_APP_LIFF_ID_PS_SSO_ARRIVAL || '1557349447-501lg8Pe',
		psssoDeparture: ENV.REACT_APP_LIFF_ID_PS_SSO_DEPARTURE || '1557349447-E4VWQ9PK',
	},
	pruid_login: `${ENV.REACT_APP_PRUID_LOGIN || 'https://liff.line.me/1557349447-nMQALjVW'
		}?s=PRUConnect`,
	pruid_verify_email: ENV.REACT_APP_PRUID_VERIFY_EMAIL || 'https://services-dev.prudential.co.th/login/sso/verify-email',
	ekyc_fe_url: ENV.REACT_APP_EKYC_FE_URL || 'https://services-dev.prudential.co.th/ekyc-ui',
	auth: {
		user: 'akdfhshfs',
		pass: '28jgh37',
	},
	buzzebee: ENV.REACT_APP_BUZZEBEE || 'https://prudentialredemptioninterface.buzzebees-uat.com/auth',
	groupEBUrl:
		ENV.REACT_APP_GROUP_EB_URL || 'https://ebportal-uat.prudential.co.th',
	consentEditable: ['DM01', 'DM02'],
	blobUrl: ENV.REACT_APP_BLOB_STORAGE_URL || 'https://stathlifeuataz1zvzryk002.blob.core.windows.net/plt-apis-public',
	// pruserviceUrl: ENV.REACT_APP_PRUSERVICE_URL || 'https://pruservices.prudential.co.th/welcome',
	errorScrollingOptions: {
		duration: 500,
		delay: 100,
		smooth: true,
		offset: -250,
	},
	pruservices: {
		homeURL: ENV.REACT_APP_PRUSERVICE_URL || 'https://pruservices-nprd.prudential.co.th/dev/welcome',
		arrival: {
			backHomeURL: ENV.REACT_APP_PRUSERVICE_ARRIVAL_URL || 'https://pruservices-nprd.prudential.co.th/uat/pruservice-web/index.html#/features/home/screens/home',
			transactionMappedRoutes: {
				PCCLAIM: '/eclaim',
				POLICYLOAN: '/policy-loan',
				UPDATECONTACTDETAILS: '/change-contact',
				UPDATEBENFITPAYOUT: '/payout-benefit',
				AUTOPREMIUMDEDUCTION: '/payment-directdebit',
				PRIVILEGES: '/privilege',
				EKYC: '/ekyc-ui',
				DOWNLOADDOCUMENT: '/documents-download',
				HELPCENTER: '/contact-us',
				AGENTDIRECTORY: '/search-partner/agent',
				WITHDRAWSPECIALBONUS: {
					ttbTheTreasure: '/Mypolicy/consent-TC',
					pruSecureSaver: '/Mypolicy/consent-pru-secure-saver-TC',
				},
				CAMPAIGNBIGREWARD: '/big-reward-campaign',
			}
		},
		departure: {
			transactionMappedRoutes: {
				POLICYLISTING: {
					redirectLiffURL: ENV.REACT_APP_PRUSERVICE_DEPARTURE_POLICYLISTING_LIFF_URL || 'https://liff.line.me/1557349447-4WDBKV2k',
					redirectRealURL: `${ENV.REACT_APP_PRUSERVICE_DEPARTURE_POLICYLISTING_URL || 'https://pruservices-nprd.prudential.co.th/dev/sso'}`,
				},
			}
		}
	},
	pruservicesV2: {
		homeURL: ENV.REACT_APP_PRUSERVICE_V2_URL || 'https://pruservices-nprd.prudential.co.th/plt/int/pruservices/app/onboarding/welcome',
		arrival: {
			backHomeURL: ENV.REACT_APP_PRUSERVICE_V2_ARRIVAL_URL || 'https://pruservices-nprd.prudential.co.th/plt/int/pruservices/app/home',
			transactionMappedRoutes: {
				NCBCLAIM: '/eclaim',
				POLICYLOAN: '/policy-loan',
				UPDATECONTACTDETAILS: '/change-contact',
				UPDATEBENFITPAYOUT: '/payout-benefit',
				AUTOPREMIUMDEDUCTION: '/payment-directdebit',
				PRIVILEGES: '/privilege',
				EKYC: '/ekyc-ui',
				DOWNLOADDOCUMENT: '/documents-download',
				HELPCENTER: '/contact-us',
				AGENTDIRECTORY: '/search-partner/agent',
				WITHDRAWSPECIALBONUS: {
					ttbTheTreasure: '/Mypolicy/consent-TC',
					pruSecureSaver: '/Mypolicy/consent-pru-secure-saver-TC',
				},
				CAMPAIGNBIGREWARD: '/big-reward-campaign',
			}
		},
		departure: {
			transactionMappedRoutes: {
				POLICYLISTING: {
					redirectLiffURL: ENV.REACT_APP_PRUSERVICE_DEPARTURE_POLICYLISTING_LIFF_URL || 'https://liff.line.me/1557349447-4WDBKV2k',
					redirectRealURL: `${ENV.REACT_APP_PRUSERVICE_V2_DEPARTURE_POLICYLISTING_URL || 'https://pruservices-nprd.prudential.co.th/dev/sso'}`,
				},
			}
		}
	},
	digitalPaymentFailRetry: ENV.REACT_APP_DIGITAL_PAYMENT_FAIL_RETRY || '1',
	sysCookieName: 'PSLINE',
};

export const google = {
	reCaptchaSiteKey: '6Ld7yrgUAAAAACV4nUFmhXxZ6b5QpAp5KKJk7mMl',
};